import React, { Suspense } from 'react';
/* eslint-disable restrict-imports/restrict-imports */
import FederalBanner from 'react-scale/components/ui/FederalBanner';
import { IS_FEDERAL } from '@scale/frontend-lib/constants';

import ScaleHead from 'design-system/Head';
import Spinner from 'design-system/Spinner';
import GlobalCSS from 'react-scale/components/legacy-css/global_css';
import LegacyCorpCSS from 'react-scale/components/legacy-css/corp-app';
import LegacyWorkerCSS from 'react-scale/components/scalers/legacy-css/worker';

const BaseLayoutUICore: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <>
    <div className="corp">
      {IS_FEDERAL && <FederalBanner />}
      <ScaleHead title="Scale - Corporate" />
      <GlobalCSS />
      <LegacyCorpCSS />
      <LegacyWorkerCSS />

      <Suspense fallback={<Spinner />}>{children}</Suspense>
      {IS_FEDERAL && <FederalBanner />}
    </div>

    <style jsx global>{`
      html,
      body,
      #root,
      #__next,
      .nextjsWrapperDiv,
      #__next [data-reactroot] {
        height: 100%;
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }
      #body {
        flex: 1;
      }

      h1.body__title {
        margin: 0 0 32px;
      }
    `}</style>

    <style jsx>{`
      .corp {
        display: flex !important;
        align-items: stretch;
        width: 100vw !important;
        max-width: 100%;
        height: 100vh !important;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
      }
    `}</style>
  </>
);

const BaseLayoutUI = React.memo(BaseLayoutUICore);

export default BaseLayoutUI;
